import { SVGProps } from 'react';

const Hospital = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 7v4m2 10v-3a2 2 0 0 0-4 0v3m4-12h-4m8 2h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2h2m12 13V5a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16"
    />
  </svg>
);
export default Hospital;
